import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import type { TableFilter } from '@pbt/pbt-ui-components'

import type { FilterOption } from '~/components/common/filters/BaseFilter'
import FeatureToggle from '~/constants/featureToggle'
import {
  getFeatureToggle,
  getInventorySubCategory,
} from '~/store/reducers/constants'

import { InventoryTableSearchFilter } from '../catalog/InventoryTableSearchFilter'

export interface SubcategoryFilterProps {
  onChange?: (selection: FilterOption) => void
  selectedCategoryFilter?: TableFilter
  selectedSubcategoryFilter?: TableFilter
}

const SubcategoryFilter = ({
  selectedCategoryFilter,
  selectedSubcategoryFilter,
  onChange,
}: SubcategoryFilterProps) => {
  const { t } = useTranslation('Common')
  const subcategoriesByCategoryId = useSelector(getInventorySubCategory)
  const isInventoryKibFiltersEnabled = useSelector(
    getFeatureToggle(FeatureToggle.INVENTORY_KIB_FILTERS),
  )

  const selectedCategoryIds = Array.isArray(selectedCategoryFilter?.value)
    ? selectedCategoryFilter.value.map(String)
    : []
  const selectedSubcategoryValues: string[] = Array.isArray(
    selectedSubcategoryFilter?.value,
  )
    ? selectedSubcategoryFilter.value.map(String)
    : []

  const relevantSubcategories = selectedCategoryIds.length
    ? selectedCategoryIds.flatMap(
        (categoryId) => subcategoriesByCategoryId[categoryId] || [],
      )
    : Object.values(subcategoriesByCategoryId || {}).flat()

  if (!isInventoryKibFiltersEnabled) return null

  return (
    <InventoryTableSearchFilter
      options={relevantSubcategories}
      placeholder={t('Common:SUB-CATEGORY')}
      selectedValues={selectedSubcategoryValues}
      onChange={onChange}
    />
  )
}

export default SubcategoryFilter
